import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../service/indentifyDevice";
import LeadForm, { ILeadFormProps } from "../forms/leadForm";
import "../../../assets/scss/components/login/loginScreen/loginScreen.scss";
import logo from "../../../assets/images/logo_white.jpg";

export interface ILeadFormScreenProps extends ILeadFormProps {
	onClose?: () => void;
}

const LeadFormScreen: React.FC<ILeadFormScreenProps> = ({ onClose, ...props }) => {
	return (
		<LoginPopup
			leftHeaderContent={!DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
			centerHeaderContent={DeviceContext().isDesktop ? <img src={logo} alt="nuvama" className="nuvama_logo"/> : undefined}
			onClose={onClose}
			className="login_scrn"
		>
			<section className="login_form lead_form">
				<div className="header mg-b30">
					<h1 className="title">Provide us with your details and we will get back in touch with you</h1>
				</div>

				<LeadForm {...props} />
			</section>
		</LoginPopup>
	);
};

export default LeadFormScreen;
